"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isOnBehalf = isOnBehalf;
var _auth = require("@ori/auth");
function isOnBehalf(tokenWithoutBearerPrefix) {
  const decodedToken = (0, _auth.decodeToken)(tokenWithoutBearerPrefix);
  return !!decodedToken?.act;
}
